import { LanguageSupport, StreamLanguage } from '@codemirror/language'
import * as yamlMode from '@codemirror/legacy-modes/mode/yaml'
import { langs as languages } from '@uiw/codemirror-extensions-langs'

import {
  IssueAutofixPreviewDetailsLocation,
  IssueDetailsLocation,
} from '@/types'

const yaml = new LanguageSupport(StreamLanguage.define(yamlMode.yaml))

export function arrayToString(data: any): string | null | undefined {
  return Array.isArray(data) ? JSON.stringify(data.sort()) : data?.toString()
}

export const highlightQueryText = (
  text: string,
  searchTerm: string,
  isLightMode: boolean,
  markStyle?: { [key: string]: string }
) => {
  if (searchTerm == null || searchTerm?.length === 0) return text

  const reg = new RegExp(`(${searchTerm})`, 'gi')

  const textParts = text?.split(reg)

  return textParts?.map((part, index) =>
    part.match(reg) ? (
      <mark
        style={{
          backgroundColor: isLightMode && 'var(--gold-3)',
          ...markStyle,
        }}
        key={index}
      >
        {part}
      </mark>
    ) : (
      part
    )
  )
}

export function isObjectLike(obj1: any, obj2: any): boolean {
  return Object.keys(obj1).reduce((acc, curr) => {
    return (
      acc && (typeof obj1[curr] === 'undefined' || obj2[curr] === obj1[curr])
    )
  }, true)
}

export function mergePropertiesWhenDefined<T>(target, fallback) {
  return Object.keys({ ...target, ...fallback }).reduce((merged, key) => {
    merged[key] =
      typeof target?.[key] !== 'undefined' ? target[key] : fallback[key]
    return merged
  }, {}) as T
}

export function numberToPercent(intl, value: number): string {
  return intl.formatNumber(value, {
    style: 'percent',
    unit: 'percent',
    unitDisplay: 'long',
    maximumFractionDigits: 2,
  })
}

// does check for the string is empty or has only whitespace , return the substitute if its empty.
export function getNameOrFallback(name: string, substitute: string) {
  if (
    name?.trim().length === 0 ||
    typeof name === 'undefined' ||
    name == null
  ) {
    return substitute
  }
  return name
}

export function getLanguageHighlighter(
  language:
    | IssueDetailsLocation['language']
    | IssueAutofixPreviewDetailsLocation['language'],
  path?: string
) {
  // We do not handle JSX and TSX separetly in the backend
  // therefore we hack a bit the recognition of the language using
  // file extension
  if (language === 'JAVASCRIPT' && path.endsWith('jsx')) {
    return languages.jsx()
  } else if (language === 'TYPESCRIPT' && path.endsWith('tsx')) {
    return languages.tsx()
  }
  switch (language) {
    case 'JAVA':
      return languages.java()
    case 'APEX':
      return languages.java()
    case 'HTML':
      return languages.html()
    case 'JAVASCRIPT':
      return languages.javascript()
    case 'JSON':
      return languages.json()
    case 'TYPESCRIPT':
      return languages.typescript()
    case 'XML':
      return languages.xml()
    case 'YAML':
      return yaml
    default:
      return languages.java()
  }
}
